import { getItemByLabelFactory, getItemByIdFactory } from './_common'
import type { ISelectItem } from '~/types/models'

export enum OrderServiceOrderStatusIds {
  NO_SERVICES = 1,
  IN_PROGRESS = 2,
  SOME_ON_HOLD = 3,
  ON_HOLD = 4,
  SOME_ACCEPTED = 5,
  ACCEPTED = 6,
  SOME_COMPLETE = 7,
  COMPLETE = 8,
  SOME_CANCELLED = 9,
  CANCELLED = 10,
}

export function getOrderServiceOrderStatii(): ISelectItem[] {
  return [
    {
      id: OrderServiceOrderStatusIds.NO_SERVICES,
      label: 'No Services',
      disabled: true,
    },
    {
      id: OrderServiceOrderStatusIds.IN_PROGRESS,
      label: 'In Progress',
      disabled: false,
    },
    {
      id: OrderServiceOrderStatusIds.SOME_ON_HOLD,
      label: 'Some On Hold',
      disabled: true,
    },
    {
      id: OrderServiceOrderStatusIds.ON_HOLD,
      label: 'On Hold',
      disabled: false,
    },
    {
      id: OrderServiceOrderStatusIds.SOME_ACCEPTED,
      label: 'Some Services Accepted',
      disabled: true,
    },
    {
      id: OrderServiceOrderStatusIds.ACCEPTED,
      label: 'Accepted',
      disabled: true,
    },
    {
      id: OrderServiceOrderStatusIds.SOME_COMPLETE,
      label: 'Some Complete',
      disabled: true,
    },
    {
      id: OrderServiceOrderStatusIds.COMPLETE,
      label: 'COMPLETE',
      disabled: true,
    },
    {
      id: OrderServiceOrderStatusIds.SOME_CANCELLED,
      label: 'Some Cancelled',
      disabled: true,
    },
    {
      id: OrderServiceOrderStatusIds.CANCELLED,
      label: 'Cancelled',
      disabled: false,
    },
  ]
}

export const getOrderServiceOrderStatusByLabel = getItemByLabelFactory(
  getOrderServiceOrderStatii
)
export const getOrderServiceOrderStatusById = getItemByIdFactory(
  getOrderServiceOrderStatii
)
